module.exports = __webpack_public_path__ + "img/nav_lv.89f9ff68.png";